import { usePieceDispatch } from '../../model/piece-context';
import { useSelectedLayer } from '../../selection/hooks/use-selected-layer';
import { LayerId, PillContent } from '../../model/types';
import { PillTextbox } from '../types';

/**
 * Reads the selected pill's content from the model and returns a patch dispatcher.
 * Resolves a standalone pill or one inside a chain (the id is looked up nested), so every
 * pill panel row reads from the model and commits via dispatch instead of capturing.
 */
export const usePillContent = (
  pill: PillTextbox
): { content: PillContent | null; patch: (p: Partial<PillContent>) => void } => {
  const dispatch = usePieceDispatch();
  const layer = useSelectedLayer();
  const content = layer?.kind === 'pill' ? layer.content : null;

  const patch = (p: Partial<PillContent>): void => {
    const id = pill.layerId as LayerId | undefined;
    if (id) dispatch({ type: 'patchLayerContent', id, patch: p });
  };

  return { content, patch };
};
